import { UserOutlined } from "@ant-design/icons";
import { Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import {
  BUTTON_KEYS,
  BUTTON_TYPE_VALUES,
  BUTTON_TYPE,
} from "@/constants/Button";
import { ButtonsPropTypes } from "@/propTypes/Button.type";

const UserAccessButton = ({
  disabled,
  loading,
  type = BUTTON_TYPE.DEFAULT,
  onUserAccessSelect,
  buttonProps = {},
}) => {
  const { t } = useTranslation();

  return (
    <Button
      data-testid="userAccessButton"
      disabled={disabled}
      icon={<UserOutlined />}
      key={BUTTON_KEYS.DELETE}
      loading={loading}
      role="button"
      type={type}
      onClick={onUserAccessSelect}
      {...buttonProps}
    >
      {t("global:manageUserAccess")}
    </Button>
  );
};

UserAccessButton.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  type: PropTypes.oneOf(BUTTON_TYPE_VALUES),
  onUserAccessSelect: PropTypes.func,
  buttonProps: ButtonsPropTypes,
};

export default UserAccessButton;
